
export const ANDROID_ICONS_DEFAULT_FOLDER = 'android-icons';
export const ANDROID_CREDENTIALS_DEFAULT_FOLDER = 'android-credentials';
export const ANDROID_GOOGLE_SERVICES_JSON = 'google-services.json';

export const ANDROID_TRACKS: WhitelabelAndroidDeploymentTracks[] = ['Alpha', 'Internal test', 'Beta', 'Production'];
export type WhitelabelAndroidDeploymentTracks = 'Alpha' | 'Internal test' | 'Beta' | 'Production';

export const WhitelabelAndroidIconsFolder = [
    'mipmap-hdpi',
    'mipmap-mdpi',
    'mipmap-xhdpi',
    'mipmap-xxhdpi',
    'mipmap-xxxhdpi'
];

export const WhitelabelAndroidIconsName = [
    'ic_launcher.png',
    'ic_launcher_foreground.png',
    'ic_launcher_round.png'
]

export const WhitelabelAndroidFullIconsName = WhitelabelAndroidIconsFolder.reduce((acc, cur) => {
    return acc.concat(WhitelabelAndroidIconsName.map(iconName => `${cur}_${iconName}`))
}, new Array());

export interface WhitelabelAndroidIconsDestination {
    [folder: string]: {
        icons: File[]
    }
}

export interface WhitelabelAndroidPayload {
    accountantId: string;
    name: string;
    intentUrl?: string;
    packageName: string;
    intentScheme?: string;
    oneSignalAppId: string;
    track: WhitelabelAndroidDeploymentTracks;
    releaseNotes: string;
    versionCode: string;
    versionName: string;
    serviceAccountPrivateKey: string | null;
    serviceAccountEmail: string | null;
}

export class WhitelabelAndroidConfig {
    public accountantId!: string;
    public intentScheme!: string;
    public packageName!: string | null;
    public name!: string;
    public status!: number;

    public keytoolLink!: string | null;
    public storeLink!: string | null;
    public googleServicesJsonLink!: string | null;
    public iconsLinks!: string[] | null;
    public appIconLink!: string | null;
    
    public serviceAccountEmail!: string | null;
    public serviceAccountPrivateKey!: string | null;

    public sha256CertificateFingerPrint!: string | null;

    public constructor(){}

    public generateEnvPropertiesFile(deepLinkHost: string): File {
        if (!deepLinkHost || !this.name || !this.packageName || !this.intentScheme)
            throw new Error('Cant create env properties file');

        const content = `
        br.com.nibo.customer.app.deeplink.host = ${deepLinkHost}
        br.com.nibo.customer.app.name = ${this.name}
        br.com.nibo.customer.app.id = ${this.packageName}
        br.com.nibo.customer.signing = true
        br.com.nibo.customer.app.intent.scheme = ${this.intentScheme}
        `;

        const blob = new Blob([content], { type: '.properties' });
        const file = new File([blob], 'env.properties');
        return file;
    }

    public static getIconsDestination(icons: File[]): WhitelabelAndroidIconsDestination {
        const destinations: WhitelabelAndroidIconsDestination = {};

        icons.forEach(icon => {
                const iconFolder: string = icon.name.substring(icon.name.indexOf('_'), -1);
                const renamedIcon: File = new File([icon], icon.name.slice(icon.name.indexOf('_') + 1), { type: icon.type })

                if (!destinations[iconFolder]) {
                    destinations[iconFolder] = {
                        icons: [],
                    }
                }

                destinations[iconFolder].icons.push(renamedIcon);
            });

        return destinations;
    }

}

export class WhitelabelAndroidConfigLogicAppPayload implements WhitelabelAndroidPayload {
    accountantId!: string;
    name!: string;
    intentUrl?: string;
    intentScheme?: string;
    oneSignalAppId!: string;
    packageName!: string;
    track!: WhitelabelAndroidDeploymentTracks;
    releaseNotes!: string;
    versionCode!: string;
    versionName!: string;
    serviceAccountPrivateKey!: string | null;
    serviceAccountEmail!: string | null; 

    public constructor(payload: WhitelabelAndroidPayload) {
        Object.assign(this, payload);
    }
}
